let currentSlide = 0;
let darkMode = 0; /* 0 = day, 1 = night */

function _reset_animation(el) {
  el.style.animation = 'none';
  el.offsetHeight; /* trigger reflow */
  el.style.animation = null; 
}

function showSlide(index) {
  const slides = document.querySelectorAll('.offd-carousel-item');
  let preSlide = currentSlide;
  if (index >= slides.length) {
    currentSlide = index - slides.length;
  } else if (index < 0) {
    currentSlide = slides.length + index;
  } else {
    currentSlide = index;
  }

  slides.forEach((slide, i) => {
    if (i === currentSlide) {
      slide.style.animation = 'emergeIn 0.6s ease-out forwards';
      slide.style.display = 'block';
    } else if (i === preSlide) {
      _reset_animation(slide);
      slide.style.animation = 'fadeOut 0.6s ease-out forwards';
    } else {
      slide.style.display = 'none';
    }
  });
}

function changeSlide(n) {
  showSlide(currentSlide + n);
}

function toggleDarkMode(containerId) {
  const container = document.querySelector('#' + containerId);
  const background = container.querySelectorAll('.offd-carousel-background-2-inner')[0];
  const overlay = container.querySelectorAll('.offd-carousel-background-2-overlay')[0];
  const slideBubble = container.querySelectorAll('.dark-mode-sliding-bubble')[0];
  const oozeImageDay = container.querySelectorAll('.ooze-img-day')[0];
  const oozeImageNight = container.querySelectorAll('.ooze-img-night')[0];
  if (!darkMode) {
    _reset_animation(background);
    _reset_animation(overlay);
    _reset_animation(slideBubble);
    background.style.animation = "rotateImage 0.5s linear forwards";
    overlay.style.animation = "darken-30 0.5s linear forwards";
    slideBubble.style.animation = "slide 0.2s linear forwards";
    oozeImageNight.style.animation = 'emergeIn 0.5s ease-out forwards';
    oozeImageDay.style.animation = 'delayOut 0.5s ease-out forwards';
    changeSlide(1);
    darkMode = 1;
  }
  else {
    _reset_animation(background);
    _reset_animation(overlay);
    _reset_animation(slideBubble);
    background.style.animation = "rotateImage 0.5s linear reverse forwards";
    overlay.style.animation = "darken-30 0.5s linear reverse forwards";
    slideBubble.style.animation = "slide 0.2s linear reverse forwards";
    oozeImageDay.style.animation = 'emergeIn 0.5s ease-out forwards';
    oozeImageNight.style.animation = 'fadeOut 0.5s ease-out forwards';
    changeSlide(-1);
    darkMode = 0;
  }
}

function toggleColorVariants(n) {
  const colorVariants = document.querySelectorAll('.offd-color-variant');
  const colorControls = document.querySelectorAll('.offd-color-control');

  colorVariants.forEach((variant, i) => {
    variant.style.animation = "";
    if (i === n * 2) {
      variant.style.opacity = darkMode ? 0 : 1;
      variant.classList.add("ooze-img-day");
    } else if (i === n * 2 + 1) {
      variant.style.opacity = darkMode ? 1 : 0;
      variant.classList.add("ooze-img-night");
    } else {
      variant.style.opacity = 0;
      variant.classList.remove("ooze-img-day");
      variant.classList.remove("ooze-img-night");
    }
  });
  
  colorControls.forEach((color, i) => {
    color.classList.remove("scary-color-button-enlarge");
    if (i === n) {
      color.classList.add("scary-color-button-enlarge");
    }
  });
}